import React from "react";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import { isMobile } from "react-device-detect";
import google from "../Images/google_pay.png";
import paytm from "../Images/paytm.png";
import phonePay from "../Images/phone_pay.png";
import cheveron from "../Images/rightCheveron.png";
import { getCurrencyByCountryCode } from "../utils/utility";
import { toast } from "react-toastify";
import "./QRCodePopup.css";

const generateDeepLinks = (upiLink) => {
  if (!upiLink || !upiLink.startsWith("upi://")) {
    return {
      googlePayDeepLink: "",
      phonePeDeepLink: "",
      paytmDeepLink: "",
      genericUPILink: upiLink || "",
    };
  }

  const encodedUPILink = upiLink;

  return {
    googlePayDeepLink: encodedUPILink.replace("upi://", "tez://upi/"),
    phonePeDeepLink: encodedUPILink.replace("upi://", "phonepe://"),
    paytmDeepLink: encodedUPILink.replace("upi://", "paytmmp://pay?"),
    genericUPILink: encodedUPILink,
  };
};

const getGpayDeepLink = (gpayupiLink) => {
  const url = new URL(gpayupiLink);
  const params = new URLSearchParams(url.search);

  // Get first word of pn
  const fullPn = decodeURIComponent(params.get("pn"));
  const firstWord = fullPn.split(" ")[0];

  // Set pn to first word
  params.set("pn", firstWord);

  // Rebuild the URL
  const updatedLink = `${url.protocol}//${url.host}${
    url.pathname
  }?${params.toString()}`;
  return updatedLink;
};

// Function to handle deep link click with fallback
// const handlePayment = (deepLink, appName) => {
//   if (!deepLink) {
//     toast.error(`Payment link for ${appName} is not available.`, {
//       position: toast.POSITION.TOP_RIGHT,
//       autoClose: 1000,
//     });
//     return;
//   }

//   if (appName === "Google Pay") {
//     deepLink = getGpayDeepLink(deepLink);
//   }

//   const now = Date.now();
//   let didLeavePage = false;
//   let hasReturned = false;

//   const onVisibilityChange = () => {
//     if (document.visibilityState === "hidden") {
//       didLeavePage = true;
//     }
//   };

//   const onFocusBack = () => {
//     hasReturned = true;
//   };

//   document.addEventListener("visibilitychange", onVisibilityChange);
//   window.addEventListener("focus", onFocusBack);

//   const iframe = document.createElement("iframe");
//   iframe.style.display = "none";
//   iframe.src = deepLink;
//   document.body.appendChild(iframe);

//   setTimeout(() => {
//     document.removeEventListener("visibilitychange", onVisibilityChange);
//     window.removeEventListener("focus", onFocusBack);
//     document.body.removeChild(iframe);

//     // Show toast only if user didn’t switch to app or never returned
//     if (!didLeavePage || (didLeavePage && !hasReturned)) {
//       toast.error(`${appName} is not installed or the action was cancelled.`, {
//         position: toast.POSITION.TOP_RIGHT,
//         autoClose: 2000,
//       });
//     }
//   }, 3000); // Slightly longer for stability

//   // Trigger intent
//   window.location.href = deepLink;
// };

const handlePayment = (deepLink, appName) => {
  if (!deepLink) {
    toast.error(`Payment link for ${appName} is not available.`, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 1000,
    });
    return;
  }

  if (appName === "Google Pay") {
    deepLink = getGpayDeepLink(deepLink);
  }

  let didLeavePage = false;
  let hasReturned = false;

  const onVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      didLeavePage = true;
    }
  };

  const onFocusBack = () => {
    hasReturned = true;
  };

  document.addEventListener("visibilitychange", onVisibilityChange);
  window.addEventListener("focus", onFocusBack);

  // Create a hidden iframe to trigger the intent
  const iframe = document.createElement("iframe");
  iframe.style.display = "none";
  iframe.src = deepLink;
  document.body.appendChild(iframe);

  // Timeout for detecting failure
  setTimeout(() => {
    document.removeEventListener("visibilitychange", onVisibilityChange);
    window.removeEventListener("focus", onFocusBack);
    document.body.removeChild(iframe);

    // 🧠 Show error only if user didn't leave the page
    if (!didLeavePage) {
      toast.error(
        `${appName} might not be installed, or the action was cancelled.`,
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        }
      );
    }
  }, 3000);

  // Fallback redirect as well
  window.location.href = deepLink;
};


function getPayeeAddressFromUpiLink(upiLink) {
  try {
    const url = new URL(upiLink);
    const params = new URLSearchParams(url.search);
    return params.get("pa") || "";
  } catch {
    return "";
  }
}

const QRCodePopup = ({
  show,
  onClose,
  loading,
  qrCodeImage,
  qrCodeData = null,
  productDetails,
  totalAmount,
  businessData,
}) => {
  // Generate dynamic deep links
  const { googlePayDeepLink, phonePeDeepLink, paytmDeepLink, genericUPILink } =
    generateDeepLinks(qrCodeData);


    console.log("businessDatabusinessData", businessData);

  const payeeAddress = getPayeeAddressFromUpiLink(qrCodeData);

  const handleCopyPayeeAddress = () => {
    if (payeeAddress) {
      navigator.clipboard.writeText(payeeAddress);
      toast.success("UPI ID Copied!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  };
  const shipCountry =
    localStorage.getItem("businessObj") &&
    JSON.parse(localStorage.getItem("businessObj"))?.shipCountry;
  const currencyCode = getCurrencyByCountryCode(
    businessData?.shipCountry || shipCountry
  );
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="payinoutpopup-qr-platform"
      id="payinout-qr-platform"
    >
      <Modal.Header>
        <button className="custom-close-btn2" onClick={onClose}>
          <i class="fas fa-arrow-left"></i>
        </button>
        <Modal.Title>Payment</Modal.Title>
        {/* {isMobile ? <Modal.Title>Pay with</Modal.Title> : <Modal.Title>Scan and Pay</Modal.Title>} */}
      </Modal.Header>
      <Modal.Body style={{ padding: "10px" }}>
        <div className="amountDesc">
          <p> Amount to be pay</p>
          <h3 style={{ marginBottom: "10px" }}>
            {" "}
            {currencyCode + totalAmount}
          </h3>
          {payeeAddress && (
            <p style={{ marginTop: "30px" }}>
              UPI ID: {payeeAddress}{" "}
              <span
                style={{ cursor: "pointer" }}
                onClick={handleCopyPayeeAddress}
                title="Copy UPI ID"
              >
                {" "}
                <i class="fa-solid fa-copy"></i>
              </span>
            </p>
          )}
        </div>
        {loading ? (
          <div style={{ textAlign: "center" }}>
            <Spinner
              animation="border"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : qrCodeImage ? (
          <div style={{ textAlign: "center" }}>
            {
              <img
                src={qrCodeImage}
                alt="QR Code"
                style={{
                  maxWidth: "90%",
                  height: "auto",
                  display: "inline-block",
                  margin: "0 auto",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  height: " 230px",
                  width: " 230px",
                  filter: "grayscale(1)",
                }}
              />
            }

            {/* Deep link buttons for mobile devices */}
            {qrCodeData && (
              <div className="merchentsWrapper">
                <p className="payWith"> Pay with</p>
                <div className="merchents">
                  <button
                    onClick={() =>
                      handlePayment(googlePayDeepLink, "Google Pay")
                    }
                    className="paymentButton"
                  >
                    <div className="merchentName">
                      <img src={google} className="merchentLogo" />
                      Google Pay
                    </div>
                    <img src={cheveron} />
                  </button>
                  <button
                    onClick={() => handlePayment(phonePeDeepLink, "PhonePe")}
                    className="paymentButton"
                  >
                    {" "}
                    <div className="merchentName">
                      <img src={phonePay} className="merchentLogo" />
                      PhonePe
                    </div>
                    <img src={cheveron} />
                  </button>
                  <button
                    onClick={() => handlePayment(paytmDeepLink, "Paytm")}
                    className="paymentButton"
                  >
                    <div className="merchentName">
                      <img src={paytm} className="merchentLogo" />
                      Paytm
                    </div>

                    <img src={cheveron} />
                  </button>
                </div>
              </div>
            )}
          </div>
        ) : (
          <p style={{ textAlign: "center", color: "red" }}>
            Failed to load QR Code.
          </p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default QRCodePopup;
